import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const ContactSection = ({ translations = {}, currentLanguage = 'en' }) => {
  const animationContainer = useRef(null);
  const animationInstance = useRef(null);

  // Traducciones completas
  const allTranslations = {
    en: {
      contactTitle: 'Contact Us',
      contactPrompt: 'Questions, Reservations, and Orders',
      phoneNumber: '+30 6973160233',
      addressText: 'Chryseidos 1-3, Kallithea 176 76, Athens, Greece',
      getDirections: '➤ ',
            whatsappAlt: 'Contact us on WhatsApp',
      mapAlt: 'Location map'
    },
    es: {
      contactTitle: 'Contáctanos',
      contactPrompt: 'Preguntas, Reservas y Pedidos',
      phoneNumber: '+30 6973160233',
      addressText: 'Chryseidos 1-3, Kallithea 176 76, Grecia',
      getDirections: 'Obtener Direcciones',
      whatsappAlt: 'Contáctanos por WhatsApp',
      mapAlt: 'Mapa de ubicación'
    },
    gr: {
      contactTitle: 'Επικοινωνία',
      contactPrompt: 'Ερωτήσεις, Κρατήσεις και Παραγγελίες',
      phoneNumber: '+30 6973160233',
      addressText: 'Χρυσειδούς 1-3, Καλλιθέα 176 76, Ελλάδα',
      getDirections: 'Οδηγίες Πρόσβασης',
      whatsappAlt: 'Επικοινωνήστε μαζί μας στο WhatsApp',
      mapAlt: 'Χάρτης τοποθεσίας'
    }
  };

  const getTranslation = (key) => {
    if (translations && translations[key]) return translations[key];
    if (allTranslations[currentLanguage] && allTranslations[currentLanguage][key]) {
      return allTranslations[currentLanguage][key];
    }
    return allTranslations.en[key] || '';
  };

  useEffect(() => {
    if (animationContainer.current && !animationInstance.current) {
      animationInstance.current = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/images/what.json',
      });
    }

    return () => {
      if (animationInstance.current) {
        animationInstance.current.destroy();
        animationInstance.current = null;
      }
    };
  }, []);

  return (
    <section className="py-20 bg-[#FFF8F0] text-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-[#FF4C29] mb-4 animate-fade-in">
          {getTranslation('contactTitle')}
        </h2>
        
        <p className="text-xl text-center text-gray-700 mb-12 animate-fade-in">
          {getTranslation('contactPrompt')}
        </p>
        
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-xl animate-fade-in-up">
          <div className="text-center space-y-6">
            <div className="flex justify-center">
              <a
                href="https://wa.me/+306973160233"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out animate-float"
                aria-label={getTranslation('whatsappAlt')}
                title={getTranslation('whatsappAlt')}
              >
                <div ref={animationContainer} className="w-12 h-12"></div>
              </a>
            </div>
            <div className="space-y-2">
              <p className="text-lg font-medium text-gray-700">
                {getTranslation('phoneNumber')}
              </p>
              <p className="text-lg font-medium text-gray-700">
                {getTranslation('addressText')}
              </p>
            </div>
            <div className="mt-6">
              <iframe
                className="w-full h-64 rounded-lg"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3146.387362295!2d23.699805815315!3d37.953527679522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zQ2hyeXNlaWRvcyAxLCBLYWxsaXRoZWEgMTc2IDc2LCBHcmVlY2U!5e0!3m2!1sen!2sgr!4v1697051234567!5m2!1sen!2sgr"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={getTranslation('mapAlt')}
                aria-label={getTranslation('mapAlt')}
              ></iframe>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Chryseidos+1,+Kallithea+176+76,+Greece"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-4 px-6 py-3 bg-[#FF9A00] text-white text-lg font-semibold rounded-lg shadow-lg hover:bg-[#E08A00] transition-all duration-300 ease-in-out transform hover:scale-105"
              >
                {getTranslation('getDirections')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;